// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C3qB","field":"styles_field__3wg7Y","fieldCol":"styles_fieldCol__3gqRm","diffCol":"styles_diffCol__2yAN2","diff":"styles_diff__3P7jk"};